var map = {
	"./en-US": [
		16936,
		1782
	],
	"./en-US.ts": [
		16936,
		1782
	],
	"./global/en-US": [
		47994,
		7156
	],
	"./global/en-US.ts": [
		47994,
		7156
	],
	"./global/zh-CN": [
		9096
	],
	"./global/zh-CN.ts": [
		9096
	],
	"./pages/en-US": [
		34299,
		9605
	],
	"./pages/en-US.ts": [
		34299,
		9605
	],
	"./pages/zh-CN": [
		66341
	],
	"./pages/zh-CN.ts": [
		66341
	],
	"./routes/en-US": [
		39475,
		7635
	],
	"./routes/en-US.ts": [
		39475,
		7635
	],
	"./routes/zh-CN": [
		87069
	],
	"./routes/zh-CN.ts": [
		87069
	],
	"./zh-CN": [
		7089
	],
	"./zh-CN.ts": [
		7089
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5839;
module.exports = webpackAsyncContext;